import { createSlice } from "@reduxjs/toolkit";
import { loadChatsAction, postGuestImage, postGuestMessage } from "./guestShop.action";
import { langChangeSuccess, loginSuccess, loginUser } from "../authenticate/authenticate.action";

const initialState = {
	chats: [],
	scrollToDown: false,
	isImagePosting: false,
	isImagePosted: false,
	isImageFailedToPost: false,
	ischatLoading: true,
	set2AdminMessage: {},
	set1AdminMessage: {},
	streaming: false,
	set1AdminMessageList: [],
	set2AdminMessageList: [],
	successMessage: "",
	errorMessage: "",
	pretextSended: "",
};

const guestShopSlicer = createSlice({
	name: "guestShop",
	initialState: initialState,
	reducers: {
		setScrollToDown: (state, action) => {
			state.scrollToDown = action.payload;
		},
		setStreaming: (state, action) => {
			state.streaming = action.payload;
		},
		removeErrorSuccessMessage: (state, action) => {
			state.errorMessage = "";
			state.successMessage = "";
		},

		addChatMessage: (state, action) => {
			state.chats.push(action.payload);
			state.scrollToDown = true;
		},
		clearPretextSended: (state, action) => {
			state.pretextSended = action.payload;
		},
		setGuestMessageData: (state, action) => {
			const {
				set1AdminMessageList,
				set2AdminMessageList,
				set1AdminMessage,
				set2AdminMessage,
				guestChats,
			} = action.payload;
			state.scrollToDown = true;
			state.chats = guestChats;

			state.set1AdminMessage = set1AdminMessage;
			state.set2AdminMessage = set2AdminMessage;
			state.set1AdminMessageList = set1AdminMessageList;
			state.set2AdminMessageList = set2AdminMessageList;
		},
	},
	extraReducers: {
		[postGuestMessage.pending]: (state) => {
			state.isMessagePosting = true;
		},
		[postGuestMessage.fulfilled]: (state, action) => {
			const { userChat, adminChat, set1Message, set2Message, pretextSended } = action.payload;

			if (adminChat) {
				const startReplaceIndex = state.chats.length - 2;
				state.chats.splice(startReplaceIndex, 2, userChat, adminChat);
			} else {
				const startReplaceIndex = state.chats.length - 1;
				state.chats.splice(startReplaceIndex, 1, userChat);
			}

			state.isMessagePosting = false;
			state.isMessagePosted = true;
			state.set1Message = set1Message;
			state.set2Message = set2Message;
			state.scrollToDown = true;
			state.streaming = true;
			state.pretextSended = pretextSended;
		},
		[postGuestMessage.rejected]: (state) => {
			state.isMessagePosting = false;
			state.isMessagePosted = false;
			state.isMessageFailed = false;
			state.chats.pop();
		},
		[postGuestImage.pending]: (state) => {
			state.isImagePosting = true;
		},
		[postGuestImage.fulfilled]: (state, action) => {
			const { userChat } = action.payload;

			const startReplaceIndex = state.chats.length - 1;
			state.chats.splice(startReplaceIndex, 1, userChat);

			state.isImagePosting = false;
			state.isImagePosted = true;
			state.scrollToDown = true;
		},
		[postGuestImage.rejected]: (state) => {
			state.isImagePosting = false;
			state.isImagePosted = false;
			state.isImageFailedToPost = true;
			state.chats.pop();
		},
		[loadChatsAction.pending]: (state) => {
			state.chatsLoading = true;
		},
		[loadChatsAction.fulfilled]: (state, action) => {
			const { chats } = action.payload;

			if (chats.length > 0) {
				state.chats.unshift(...chats);
			}

			state.chatsLoading = false;
		},
		[loadChatsAction.rejected]: (state) => {
			state.chatsLoading = false;
		},
		[loginUser.fulfilled]: (state, action) => {
			const {
				set1AdminMessageList,
				set2AdminMessageList,
				set1AdminMessage,
				set2AdminMessage,
				guestChats,
			} = action.payload;

			state.scrollToDown = true;
			state.chats = guestChats;

			state.set1AdminMessage = set1AdminMessage;
			state.set2AdminMessage = set2AdminMessage;
			state.set1AdminMessageList = set1AdminMessageList;
			state.set2AdminMessageList = set2AdminMessageList;
		},
		[loginSuccess.fulfilled]: (state, action) => {
			const {
				set1AdminMessageList,
				set2AdminMessageList,
				set1AdminMessage,
				set2AdminMessage,
				guestChats,
			} = action.payload;

			state.scrollToDown = true;
			state.chats = guestChats;
			state.set1AdminMessage = set1AdminMessage;
			state.set2AdminMessage = set2AdminMessage;
			state.set1AdminMessageList = set1AdminMessageList;
			state.set2AdminMessageList = set2AdminMessageList;
		},
		[langChangeSuccess.fulfilled]: (state, action) => {
			const {
				set1AdminMessageList,
				set2AdminMessageList,
				set1AdminMessage,
				set2AdminMessage,
				guestChats,
			} = action.payload;

			state.scrollToDown = true;
			state.chats = guestChats;
			state.set1AdminMessage = set1AdminMessage;
			state.set2AdminMessage = set2AdminMessage;
			state.set1AdminMessageList = set1AdminMessageList;
			state.set2AdminMessageList = set2AdminMessageList;
		},
	},
});

export const {
	setScrollToDown,
	setStreaming,
	removeErrorSuccessMessage,
	addChatMessage,
	clearPretextSended,
	setGuestMessageData,
} = guestShopSlicer.actions;
export default guestShopSlicer.reducer;
